import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { Select2OptionData } from 'ng2-select2';
import swal from 'sweetalert2';
import { DeviceUtility } from '../../shared/utilities/device.utility';
import { RegisterUser } from '../../shared/models/register-user.model';
import { ContractService } from '../../shared/services/contract.service';

declare var jQuery: any;

@Component({
  selector: 'app-register-user',
  templateUrl: './register-user.component.html',
  styleUrls: ['./register-user.component.css']
})
export class RegisterUserComponent implements OnInit {

  public tipoUsuario: Select2OptionData[];

  isBeneficiary: boolean;

  notEqualMail: boolean;

  model: RegisterUser;

  recaptcha: string;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _contractService: ContractService
  ) {
    this.model = new RegisterUser("", "", "", "", "-1", "", "", false, false);
  }

  ngOnInit() {
    this.tipoUsuario = [
      { id: "-1", text: "Seleccione un tipo..." },
      { id: "1", text: "Contratante" },
      { id: "2", text: "Beneficiario" }
    ];
  }

  public changed(e: any): void {
    this.isBeneficiary = false;
    if (e.value === "2") {
      this.isBeneficiary = true;
    }
    this.model.tipoUsuario = e.value;
  }

  public pruebaChange(e: any) : void{
    //console.log(e);
    let _email2 = e.target.value;
    this.notEqualMail = false;

    if (_email2 !== this.model.email) {
      this.notEqualMail = true;
    }
  }

  back() {
    sessionStorage.clear();
    this._router.navigate(['/auth/register']);
  }

  resolved(captchaResponse: string) {
    //console.log(`Resolved captcha with response ${captchaResponse}:`);
    this.recaptcha = captchaResponse;
  }

  infoContract() {

    swal({
      width: 600,
      showCloseButton: true,
      imageClass: 'imgLogo',
      imageUrl: './assets/images/carnet_mp.jpg',
      imageWidth: 600,
      animation: true,
      allowOutsideClick: false,
      confirmButtonClass: 'btn btn-info btn-confirm-modal',
      confirmButtonText: 'Volver',
      buttonsStyling: false,
      focusConfirm: false,
    });

  }

  condicionesInfo() {
    if (DeviceUtility.isMobileDevice()) {
      var link = document.createElement('a');
      link.href = "./assets/files/condiciones_uso_info.pdf";
      link.download = "condiciones_uso_info.pdf";
      link.click();

    }
    else {

      swal({
        width: 820,
        title: 'Condiciones de Uso Información',
        showCloseButton: true,
        html: `
        <object id="previewFormato" data="./assets/files/condiciones_uso_info.pdf" type="application/pdf" width="800" height="800">            
        </object>       
        `,
        confirmButtonClass: 'btn btn-primary',
        confirmButtonText: 'Cerrar',
        allowOutsideClick: false,
        buttonsStyling: false,
        focusConfirm: false
      });

    }

  }

  onSubmit() {
    if (this.model.tipoUsuario === '-1') {
      swal({
        title: 'Tipo usuario',
        html: '<p style="font-size:14px">No ha seleccionado el tipo de usuario</p>',
        type: 'warning',
        confirmButtonClass: 'btn btn-primary',
        buttonsStyling: false,
        focusConfirm: false
      });
      return;
    }

    if (this.model.tipoUsuario === '2' && (this.model.numBeneficiario === null || this.model.numBeneficiario === '')) {
      swal({
        title: 'Número de Beneficiario',
        html: '<p style="font-size:14px">No ingresado el número de Beneficiario</p>',
        type: 'warning',
        confirmButtonClass: 'btn btn-primary',
        buttonsStyling: false,
        focusConfirm: false
      });
      return;
    }

    if (parseInt(this.model.numBeneficiario) < 1) {
      swal({
        title: 'Número de Beneficiario',
        html: '<p style="font-size:14px">El número de Beneficiario es incorrecto</p>',
        type: 'warning',
        confirmButtonClass: 'btn btn-primary',
        buttonsStyling: false,
        focusConfirm: false
      });
      return;
    }

    if (this.model.aceptaCondiciones === false) {
      swal({
        title: 'Condiciones de uso de información',
        html: '<p style="font-size:14px">Sr Usuario, para continuar debe aceptar las condiciones de uso</p>',
        type: 'warning',
        confirmButtonClass: 'btn btn-primary',
        buttonsStyling: false,
        focusConfirm: false
      });
      return;
    }

    if(this.model.email !== this.model.email2){
      swal({
        title: 'Validación de email',
        html: '<p style="font-size:14px">No coinciden los mail registrados</p>',
        type: 'warning',
        confirmButtonClass: 'btn btn-primary',
        buttonsStyling: false,
        focusConfirm: false
      });
      return;
    }

    if (this.recaptcha === undefined || this.recaptcha === null) {

      swal({
        title: 'reCAPTCHA',
        html: '<p style="font-size:14px">No ha resuelto el captcha</p>',
        type: 'warning',
        confirmButtonClass: 'btn btn-primary',
        buttonsStyling: false,
        focusConfirm: false
      });
      return;

    }
    //console.log(this.model);  

    this._contractService.postConsultaUsuarioRegistradoContrato({ user: this.model.email, contractNumber: this.model.numContrato }).subscribe(
      resu => {
        if (resu) {
          swal({
            title: 'Lo Sentimos',
            html: '<p style="font-size:14px">Tu usuario ' + this.model.email + ' ya se encuentra registrado para el contrato número ' + this.model.numContrato + '</p>',
            type: 'info',
            confirmButtonClass: 'btn btn-primary',
            buttonsStyling: false,
            focusConfirm: false
          });
        } else {
          this._contractService.getValidaExistente(this.model.numContrato, this.model.identificacion).subscribe(
            res => {
              if (res) {

                swal({
                  title: 'Lo Sentimos',
                  html: '<p style="font-size:14px">Tu usuario ya se encuentra registrado</p>',
                  type: 'info',
                  confirmButtonClass: 'btn btn-primary',
                  buttonsStyling: false,
                  focusConfirm: false
                });

              } else {

                this._contractService.getValidateContract(this.model.numContrato, this.model.identificacion).subscribe(
                  res => {
                    if (res) {

                      sessionStorage.removeItem('registerUser');

                      sessionStorage.setItem('registerUser', JSON.stringify(this.model));

                      this._router.navigate(['/auth/register/user/questions']);

                    } else {
                      swal({
                        title: 'Lo Sentimos',
                        html: '<p style="font-size:14px">El número de contrato no fue localizado <br/>Por favor verifica tu número de contrato o número de identificación</p>',
                        type: 'info',
                        confirmButtonClass: 'btn btn-primary',
                        buttonsStyling: false,
                        focusConfirm: false
                      });
                    }
                  },
                  err => {
                    swal({
                      title: 'Lo Sentimos',
                      html: '<p style="font-size:14px">Por favor verifica tu número de contrato o número de identificación</p>',
                      type: 'info',
                      confirmButtonClass: 'btn btn-primary',
                      buttonsStyling: false,
                      focusConfirm: false
                    });
                    //console.log(err);
                  }
                );

              }
            },
            err => {
              swal({
                title: 'Lo Sentimos',
                html: '<p style="font-size:14px">Por favor verifica tu número de contrato o número de identificación</p>',
                type: 'info',
                confirmButtonClass: 'btn btn-primary',
                buttonsStyling: false,
                focusConfirm: false
              });
              //console.log(err);
            }
          );
        }
      },
      err => {

      }
    );

  }

}



// WEBPACK FOOTER //
// /app/src/app/auth/register-user/register-user.component.ts